export abstract class TelemetryService {
  public abstract userHasTelemetryEnabled(): Promise<boolean>;
}
